import useJwt from '../jwt-logic/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {})
export default jwt
